import { useMutation } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useCreatePaPatientMatch() {
  return useMutation({
    ...apiClient.addPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostMutation(),
  })
}
